import { Pane } from 'evergreen-ui';
import styles from './ColorPalette.module.scss';

export const ColorPaletteContainer = ({ children }) => (
  <Pane className={styles.paletteContainer}>
    {children}
  </Pane>
)
